/* Vignettes du sélecteur de bundle — bague Elora.
   Deux principes, et tout en découle :
   🔴 1. La vignette ne calcule rien : elle RECOPIE la photo du haut. C'est ce qui garantit que
         tout scintille au même rythme et se fige ensemble — une rotation parallèle dérive.
   🔴 2. La bague est DÉTOURÉE à la volée : le concurrent pose ses bagues sans aucun fond, et nos
         photos ont un fond #F1EEE7 qui dessinait un rectangle sur la carte blanche.
   Comportement : les deux anneaux suivent le hero ; dès que les DEUX pierres d'un anneau sont
   choisies, cet anneau se fige ; l'anneau 1 apparaît dans les deux offres. */
(() => {
  const CFG = window.ELORA_CFG;
  if (!CFG || !CFG.base) return;
  const MOIS = ["january","february","march","april","may","june",
                "july","august","september","october","november","december"];
  const V = CFG.v ? ("?v=" + CFG.v) : "";
  const PREFIXE = CFG.prefixe || "svl-elora";
  const HERO    = CFG.hero    || "svl-elora-01-hero";
  const ARGENT  = (CFG.argent || "silver").toLowerCase();
  const url = (metal, l, r) => `${CFG.base}${PREFIXE}-${metal==="silver"?"silver2":metal}-${MOIS[l]}-${MOIS[r]}.webp${V}`;

  /* cadrage de la bague seule dans les photos 1000x1000 (ombre portée et filigrane exclus) */
  const CROP = {x:95, y:335, w:808, h:395};
  const CW = 404, CH = 198;            /* on détoure en petit : ~80 000 px, quelques ms */
  const T0 = 46, T1 = 96;              /* rampe d'alpha : l'ombre portée s'efface en douceur */

  const cache = new Map();
  function detourer(src) {
    if (cache.has(src)) return Promise.resolve(cache.get(src));
    return new Promise(res => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onerror = () => res(src);                 /* en cas d'échec on garde l'image telle quelle */
      img.onload = () => {
        try {
          const c = document.createElement("canvas");
          c.width = CW; c.height = CH;
          const g = c.getContext("2d", {willReadFrequently:true});
          g.drawImage(img, CROP.x, CROP.y, CROP.w, CROP.h, 0, 0, CW, CH);
          const d = g.getImageData(0, 0, CW, CH), p = d.data;
          /* la couleur du fond : la médiane des bords */
          const ech = [];
          for (let x = 0; x < CW; x += 3) { ech.push(4*x); ech.push(4*((CH-1)*CW + x)); }
          for (let y = 0; y < CH; y += 3) { ech.push(4*(y*CW)); ech.push(4*(y*CW + CW-1)); }
          const med = k => { const v = ech.map(i => p[i+k]).sort((a,b)=>a-b); return v[v.length>>1]; };
          const fr = med(0), fg = med(1), fb = med(2);
          const dist = i => Math.abs(p[i]-fr) + Math.abs(p[i+1]-fg) + Math.abs(p[i+2]-fb);
          /* 🔴 remplissage depuis les BORDS : les gemmes claires au centre ne sont pas connectées,
             elles restent donc opaques. Un simple seuil global les effacerait. */
          const vu = new Uint8Array(CW*CH), pile = [];
          const pousser = n => { if (!vu[n] && dist(4*n) <= T1) { vu[n] = 1; pile.push(n); } };
          for (let x = 0; x < CW; x++) { pousser(x); pousser((CH-1)*CW + x); }
          for (let y = 0; y < CH; y++) { pousser(y*CW); pousser(y*CW + CW-1); }
          while (pile.length) {
            const n = pile.pop(), x = n % CW, y = (n - x) / CW;
            if (x > 0)     pousser(n-1);
            if (x < CW-1)  pousser(n+1);
            if (y > 0)     pousser(n-CW);
            if (y < CH-1)  pousser(n+CW);
          }
          for (let n = 0; n < CW*CH; n++) {
            if (!vu[n]) continue;
            const t = (dist(4*n) - T0) / (T1 - T0);
            p[4*n+3] = t <= 0 ? 0 : (t >= 1 ? 255 : (t*255)|0);
          }
          g.putImageData(d, 0, 0);
          const out = c.toDataURL("image/png");
          cache.set(src, out); res(out);
        } catch (e) { res(src); }
      };
      img.src = src;
    });
  }

  function demarrer() {
    const svb = document.querySelector("[data-svb]");
    const choix = document.querySelector(".svb__choices");
    if (!svb || !choix) return false;
    const dansLePanier = el => !!el.closest(
      "cart-drawer, cart-drawer-items, #main-cart-items, .cart-item, .drawer, .svb__choices");
    /* 🔴 le nom du hero a souvent déjà été remplacé par une combinaison : on accepte les 2 formes */
    const hero = [...document.querySelectorAll("img")].find(i => {
      const s = (i.getAttribute("src")||"") + (i.getAttribute("srcset")||"") + (i.currentSrc||"");
      return (s.includes(HERO) || s.includes(PREFIXE+"-gold-") || s.includes(PREFIXE+"-silver"))
             && !dansLePanier(i);
    });
    if (!hero) return false;

    const vign = {1:[], 2:[]};
    choix.querySelectorAll(".svb__choice").forEach(btn => {
      btn.querySelectorAll(".svb__images svg").forEach((svg, i) => {
        const n = i+1;
        if (vign[n]) { svg.dataset.vig = String(n); vign[n].push(svg); }
      });
    });
    const dernier = {1:null, 2:null};
    function poser(ring, src) {
      if (dernier[ring] === src) return;
      dernier[ring] = src;
      detourer(src).then(u => {
        if (dernier[ring] !== src) return;           /* une autre image est arrivée entre-temps */
        (vign[ring]||[]).forEach(svg => {
          svg.setAttribute("viewBox", `0 0 ${CW} ${CH}`);
          svg.querySelectorAll("image").forEach(im => {
            im.setAttribute("href", u);
            im.setAttribute("width", CW); im.setAttribute("height", CH);
          });
          /* 🔴 On ne révèle qu'ICI : avant, la vignette affichait la photo générique avec son
             ANCIEN cadrage, puis sautait au nouveau. C'est ce saut que voyait Lucas.
             🔴 Et la carte du duo contient DEUX bagues : on attend que les deux soient posées,
                sinon on révélerait une carte à moitié brute. */
          const zone = svg.closest(".svb__images");
          if (zone && [...zone.querySelectorAll("image")]
                .every(i => (i.getAttribute("href")||"").startsWith("data:")))
            zone.classList.add("svb-prete");
        });
      });
    }
    const metal = () => {
      const on = svb.querySelector('.svb__swatch[aria-pressed="true"]');
      return ((on && on.dataset.color)||"").toLowerCase() === ARGENT ? "silver" : "gold";
    };
    /* on suit l'INTERACTION : le thème présélectionne le 1er mois des deux côtés */
    const touche = {1:{left:false,right:false}, 2:{left:false,right:false}};
    const val = (ring, cote) => {
      if (!touche[ring][cote]) return null;
      const s = svb.querySelector(`select[name="${cote}-${ring}"]`);
      const v = s && s.value;
      return (v === "" || v == null) ? null : parseInt(v, 10);
    };
    function rafraichir(ring) {
      const g = val(ring,"left"), d = val(ring,"right");
      if (g !== null && d !== null) poser(ring, url(metal(), g, d));
      else {
        /* 🔴 l'ATTRIBUT src, pas currentSrc : currentSrc garde l'ancienne image tant que la
           nouvelle n'est pas chargée, ce qui décalait les vignettes d'une image entière. */
        const u = hero.getAttribute("src") || hero.currentSrc;
        if (u) poser(ring, u);
      }
    }
    const tout = () => { rafraichir(1); rafraichir(2); };

    /* 🔴 Quand la cliente a choisi l'anneau 1, la photo du haut SE FIGE — et l'anneau 2, qui la
       suivait, se figeait avec elle. Or il n'est pas encore choisi : il doit continuer à tourner.
       On prend donc le relais dès que le hero ne bouge plus depuis plus de 2,5 s. */
    let dernierTick = Date.now();
    new MutationObserver(() => { dernierTick = Date.now(); tout(); })
      .observe(hero, {attributes:true, attributeFilter:["src","srcset"]});

    const alea = () => Math.floor(Math.random()*12);
    setInterval(() => {
      if (Date.now() - dernierTick < 2500) return;       /* le hero mène encore la danse */
      [1,2].forEach(ring => {
        if (val(ring,"left") !== null && val(ring,"right") !== null) return;  /* figé : on n'y touche pas */
        poser(ring, url(metal(), alea(), alea()));
      });
    }, 1500);
    svb.addEventListener("change", e => {
      const s = e.target.closest("select");
      const m = s && /^(left|right)-(\d)$/.exec(s.name||"");
      if (m) { touche[m[2]][m[1]] = true; rafraichir(m[2]); }
    });
    svb.addEventListener("click", e => {
      if (e.target.closest(".svb__swatch")) setTimeout(tout, 30);
    });
    tout();
    return true;
  }
  /* filet : quoi qu'il arrive la vignette redevient visible — on ne laisse jamais un trou */
  setTimeout(() => document.querySelectorAll(".svb__images")
    .forEach(e => e.classList.add("svb-prete")), 2500);
  let essais = 0;
  const tenter = () => { if (demarrer() || ++essais > 40) return; setTimeout(tenter, 80); };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", tenter);
  else tenter();
})();
